import React, { useEffect, useState } from "react";
import { formatClassicSiteError } from "../classicSite.utils";

/**
 * @param {Object} props
 * @param {string} props.title
 * @param {() => Promise<unknown>} props.load
 * @param {(data: unknown) => React.ReactNode} props.render
 * @param {string} [props.emptyMessage]
 */
export default function ReadOnlyListPanel({
  title,
  load,
  render,
  emptyMessage = "No records returned.",
}) {
  const [state, setState] = useState({ loading: true, error: null, data: null });

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, error: null, data: null });
    load()
      .then((data) => {
        if (!cancelled) setState({ loading: false, error: null, data });
      })
      .catch((err) => {
        if (!cancelled) {
          setState({ loading: false, error: formatClassicSiteError(err), data: null });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [load]);

  return (
    <section className="cs-panel">
      <h2 className="cs-panel__title">{title}</h2>
      {state.loading ? <p className="cs-panel__status">Loading…</p> : null}
      {state.error ? (
        <p className="cs-panel__error" role="alert">
          {state.error}
        </p>
      ) : null}
      {!state.loading && !state.error ? (
        <div className="cs-panel__body">
          {state.data == null ||
          (Array.isArray(state.data) && state.data.length === 0) ||
          (state.data?.results && state.data.results.length === 0) ? (
            <p className="cs-panel__empty">{emptyMessage}</p>
          ) : (
            render(state.data)
          )}
        </div>
      ) : null}
    </section>
  );
}
